module.exports = __webpack_public_path__ + "static/media/Braum_0.f167cb59.jpg";